module.exports = __webpack_public_path__ + "static/img/report_img_zglxsaqtb.9920439.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/report_img_zglxsaqtb.png
// module id = zstD
// module chunks = 21